$(function () {
	var today = new Date();
	$('.cmbARRY').val(today.getFullYear());
	$('.cmbARRM').val(("00" + (today.getMonth() + 1)).slice(-2));
	$('.cmbARRD').val(("00" + today.getDate()).slice(-2));

	$('.cmbARRY').focusin(function () {
		$('.js-datepicker').datepicker('show');
	})
	$('.cmbARRM').focusin(function () {
		$('.js-datepicker').datepicker('show');
	})
	$('.cmbARRD').focusin(function () {
		$('.js-datepicker').datepicker('show');
	})
	$.get("https://holidays-jp.github.io/api/v1/date.json", function (holidaysData) {
		$('.js-datepicker').datepicker({
			dateFormat: "yy/mm/dd", dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
			showOn: "button",
			beforeShow: function (input, inst) {
				//開く前に日付を上書き
				var year = $(this).parent().find(".cmbARRY").val();
				var month = $(this).parent().find(".cmbARRM").val();
				var date = $(this).parent().find(".cmbARRD").val();
				$(this).datepicker("setDate", year + "/" + month + "/" + date)
			},
			onSelect: function (dateText, inst) {
				//カレンダー確定時にフォームに反映
				var dates = dateText.split('/');
				$(this).parent().find(".cmbARRY").val(dates[0]);
				$(this).parent().find(".cmbARRM").val(dates[1]);
				$(this).parent().find(".cmbARRD").val(dates[2]);
			},
			beforeShowDay: function (date) {
				if (date.getDay() == 0) {
					return [true, 'day-sunday', null];
				} else if (date.getDay() == 6) {
					return [true, 'day-saturday', null];
				}

				var holidays = Object.keys(holidaysData);
				for (var i = 0; i < holidays.length; i++) {
					var holiday = new Date(Date.parse(holidays[i]));
					if (holiday.getYear() == date.getYear() &&
						holiday.getMonth() == date.getMonth() &&
						holiday.getDate() == date.getDate()) {
						return [true, 'day-holiday', null];
					}
				}

				return [true, 'day-weekday', null];
			},
			minDate: '0d',
			maxDate: '1y-1d',

		});
	});

	$('.chkymd').change(function () {
		if ($(this).prop("checked")) {
			$('.cmbARRY').prop('disabled', true);
			$('.cmbARRM').prop('disabled', true);
			$('.cmbARRD').prop('disabled', true);
		} else {
			$('.cmbARRY').prop('disabled', false);
			$('.cmbARRM').prop('disabled', false);
			$('.cmbARRD').prop('disabled', false);
		}
	})
	$('.chkpsn').change(function () {
		if ($(this).prop("checked")) {
			$('.cmbPerson0').prop('disabled', true);
		} else {
			$('.cmbPerson0').prop('disabled', false);
		}
	})
})
